function hardwareLog(name,...args){}export default{hardwareLog};